import React from "react";
import CustomTable from "../../../../../components/table/CustomTable";
import {MaterialRequestHistoryTableApp} from "../../Functionality/MaterialRequest/MaterialRequestHistoryTableApp";
import {MaterialRequestHeader} from "./MaterialRequestHeader";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const MaterialRequestHistoryTable = ({
    optionView,
    handleBtnRequest,
    handleBtnHistory,
    option,
    setBodyForExport,
    searchElement,
    setSearchElement,
    setSearch,
    simpleSearch,
    setSimpleSearch,
    finalArray,
    modified,
    setModified,
    setCriteria
}) => {
    const {
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        pagination,
        rowsPerPage,
        results,
        setResults,
        getData
    } = MaterialRequestHistoryTableApp({
        option,
        setBodyForExport,
        searchElement,
        finalArray,
        modified,
        setModified,
        setCriteria,
    });

    return (
        <>
            <MaterialRequestHeader
                optionView={optionView}
                handleBtnRequest={handleBtnRequest}
                handleBtnHistory={handleBtnHistory}
                searchId={searchId}
                setBodyForExport={setBodyForExport}
                setResults={setResults}
                results={results}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                getData={getData}
            />
            <div className={"mt-3"}>
                <CustomTable
                    tableId={tableId}
                    searchId={searchId}
                    checkbox={false}
                    thead={thead}
                    tbody={tbody}
                    columnActions={true}
                    getActionsButtons={getActionsButtons}
                    textNotInformation={"you_dont_have_any_records"}
                />
                {pagination()}
            </div>
        </>
    );
};

export default MaterialRequestHistoryTable;
